import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { GET_BUSINESS_INFO } from '#client/queries/getBusinessInfo';

function useBusinessEntityInfo() {
  const { businessEntityUuid } = useBusinessEntity();
  const { loading, data, error } = useQuery(GET_BUSINESS_INFO, {
    noThrow: true,
    skip: !businessEntityUuid,
    variables: {
      businessEntityUuid
    }
  });

  useError(error);

  return {
    loading,
    hasError: Boolean(error),
    businessEntityInfo: data?.businessEntity
  };
}

export { useBusinessEntityInfo };
